import { render, staticRenderFns } from "./collectDetail.vue?vue&type=template&id=47d07a61&scoped=true&"
import script from "./collectDetail.vue?vue&type=script&lang=js&"
export * from "./collectDetail.vue?vue&type=script&lang=js&"
import style0 from "./collectDetail.vue?vue&type=style&index=0&id=47d07a61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d07a61",
  null
  
)

export default component.exports